import PropTypes from 'prop-types';
import { set, sub } from 'date-fns';
import { noCase } from 'change-case';
import { faker } from '@faker-js/faker';
import { useState, useEffect,useCallback } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";


// @mui
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  Tooltip,
  Divider,
  Popover,
  Typography,
  IconButton,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton,
} from '@mui/material';

import {
  Link as RouterLink,
  useNavigate,
  useParams,
  useLocation,
  NavLink,
} from "react-router-dom";

import * as userActions from "../../../actions/userActions";
// utils
import { fToNow } from '../../../utils/formatTime';
// components
import Iconify from '../../../components/iconify';
import Scrollbar from '../../../components/scrollbar';

import config from "../../../config";
import { encryptData } from '../../../utils/cryptoUtils';

 
// ----------------------------------------------------------------------

const NOTIFICATIONS = [
  {
    id: faker.datatype.uuid(),
    title: 'Your order is placed',
    description: 'waiting for shipping',
    avatar: null,
    type: 'order_placed',
    createdAt: set(new Date(), { hours: 10, minutes: 30 }),
    isUnRead: true,
  },
  {
    id: faker.datatype.uuid(),
    title: faker.name.fullName(),
    description: 'answered to your comment on the Minimal',
    avatar: '/assets/images/avatars/avatar_2.jpg',
    type: 'friend_interactive',
    createdAt: sub(new Date(), { hours: 3, minutes: 30 }),
    isUnRead: true,
  },
  {
    id: faker.datatype.uuid(),
    title: 'You have new message',
    description: '5 unread messages',
    avatar: null,
    type: 'chat_message',
    createdAt: sub(new Date(), { days: 1, hours: 3, minutes: 30 }),
    isUnRead: false,
  },
  {
    id: faker.datatype.uuid(),
    title: 'You have new mail',
    description: 'sent from Guido Padberg',
    avatar: null,
    type: 'mail',
    createdAt: sub(new Date(), { days: 2, hours: 3, minutes: 30 }),
    isUnRead: false,
  },
  {
    id: faker.datatype.uuid(),
    title: 'Delivery processing',
    description: 'Your order is being shipped',
    avatar: null,
    type: 'order_shipped',
    createdAt: sub(new Date(), { days: 3, hours: 3, minutes: 30 }),
    isUnRead: false,
  },
];


const NotificationsPopover = (props) =>{
  // const [notifications, setNotifications] = useState(NOTIFICATIONS); 
  const [notifications, setNotifications] = useState([]);  

  const getNotifications = useCallback(() => { 
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj); 
     const response = props.actions.getUserNotificationsData(requestData); 
      response.then((result) => {
        if (result.data.success === 1) {
              setNotifications(result.data.JSON_DATA);
        } else{ 
          setNotifications([]);
        }
       }).catch((error) => {
      });
  }, [setNotifications]);

  const readNotifications = useCallback((notificationId='') => {

     let obj = { 'action': 'all'};
    if(notificationId !=='' && notificationId !== undefined){
        obj = { "notification_id":notificationId};  // mark individual notification as read notification
    }  
    const requestData = encryptData(obj); 
     const response = props.actions.readNotifications(requestData); 
      response.then((result) => {
        if (result.data.success === 1) {
              setNotifications(result.data.JSON_DATA);
        } 
       }).catch((error) => {
      });
  }, [setNotifications]);
   
  useEffect(() => {

    // Implementing the setInterval method 
    const interval = setInterval(() => { 
        getNotifications(); 
    }, 10000); 

      
  }, [getNotifications]);


  const navigate = useNavigate();
  const totalUnRead = notifications.filter((item) => item.isUnRead === true).length;

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleMarkAllAsRead = () => {

    readNotifications(); 
    setNotifications(
      notifications.map((notification) => ({
        ...notification,
        isUnRead: false,
      }))
    );
  };

  const handleItemClick = (item) => {
 
   // alert(item?.lead_id);
    if( item?.lead_id && item?.lead_id >0  ){
      const tabName = item?.tab_name;
      const encodedId = btoa(String(item?.lead_id));

      readNotifications(item?.id); 
      if(tabName !==''){
      //  navigate(`/dashboard/edit-lead/${encodedId}/${tabName}`);

        if( tabName === 'vivriti_application'){
          navigate(`/dashboard/vivriti-application-details/${encodedId}/${encodedId}`);
        }else{
            navigate(`/dashboard/edit-lead/${encodedId}`);
        }     
      }else{
        navigate(`/dashboard/edit-lead/${encodedId}`);
      } 
      setOpen(null);
    }

    
    console.log("item = ",item);
   // alert(item);
  };

  

  return (
    <>
      <IconButton className='d-none-' color={open ? 'primary' : 'default'} onClick={handleOpen} sx={{ width: 40, height: 40 }}>
        <Badge badgeContent={totalUnRead} color="error">
          <Iconify icon="eva:bell-fill" />
        </Badge>
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mt: 1.5,
            ml: 0.75,
            width: 360,
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">Notifications</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              You have {totalUnRead} unread messages
            </Typography>
          </Box>

          {totalUnRead > 0 && (
            <Tooltip title=" Mark all as read">
              <IconButton color="primary" onClick={handleMarkAllAsRead}>
                <Iconify icon="eva:done-all-fill" />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Scrollbar sx={{ height: { xs: 340, sm: 'auto' } }}>
          <List
            disablePadding
            subheader={
              <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                  { (notifications.length >0 ) && ( "New" )}
              </ListSubheader>
            }
          >
            {notifications.map((notification) => (
              <NotificationItem 
              key={notification.id} 
              notification={notification}  
             /* onClick={() => handleItemClick(notification)}  */
              handleItemClick={handleItemClick}
              navigate={navigate}
              />
            ))}
          </List>

         { /* <List
            disablePadding
            subheader={
              <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                Before that
              </ListSubheader>
            }
          >
            {notifications.slice(2, 5).map((notification) => (
              <NotificationItem key={notification.id} notification={notification}  onClick={() => handleItemClick(notification.id)}  />
            ))}
          </List> */}
        </Scrollbar>

        <Divider sx={{ borderStyle: 'dashed' }} />

        { /* <Box sx={{ p: 1 }}>
          <Button fullWidth disableRipple>
            View All
          </Button>
        </Box> */}
      </Popover>
    </>
  );
}

function mapStateToProps(state) {
  return {
    isFetching: state.isFetching,
    deviceToken: state.deviceToken,
  }
}
 
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(NotificationsPopover);


// ----------------------------------------------------------------------

NotificationItem.propTypes = {
  notification: PropTypes.shape({
    createdAt: PropTypes.instanceOf(Date),
    id: PropTypes.string,
    isUnRead: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
    avatar: PropTypes.any,
  }),
};

function NotificationItem({ notification ,handleItemClick,navigate}) {
  const { avatar, title } = renderContent(notification);

  return ( 
    <ListItemButton
      onClick={() => handleItemClick(notification)}
      sx={{
        py: 1.5,
        px: 2.5,
        mt: '1px',
        ...(notification.isUnRead && {
          bgcolor: 'action.selected',
        }),
      }}
    >
      <ListItemAvatar>
        <Avatar sx={{ bgcolor: 'background.neutral' }}>{avatar}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={title}
        secondary={
          <Typography
            variant="caption"
            sx={{
              mt: 0.5,
              display: 'flex',
              alignItems: 'center',
              color: 'text.disabled',
            }}
          >
            <Iconify icon="eva:clock-outline" sx={{ mr: 0.5, width: 16, height: 16 }} />
            {fToNow(notification.createdAt)}
          </Typography>
        }
      />
    </ListItemButton>
  );
}

// ----------------------------------------------------------------------

function renderContent(notification) {
  const title = (
    <Typography variant="subtitle2">
      {notification.title}
      <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
       {notification.description}
      </Typography>
    </Typography>
  );

  if (notification.type === 'order_placed') {
    return {
      avatar: <img alt={notification.title} src="/assets/icons/ic_notification_package.svg" />,
      title,
    };
  }
  if (notification.type === 'order_shipped') {
    return {
      avatar: <img alt={notification.title} src="/assets/icons/ic_notification_shipping.svg" />,
      title,
    };
  }
  if (notification.type === 'mail') {
    return {
      avatar: <img alt={notification.title} src="/assets/icons/ic_notification_mail.svg" />,
      title,
    };
  }
  if (notification.type === 'chat_message') {
    return {
      avatar: <img alt={notification.title} src="/assets/icons/ic_notification_chat.svg" />,
      title,
    };
  }
  return {
    avatar: notification.avatar ? <img alt={notification.title} src={notification.avatar} /> : null,
    title,
  };
}
